(() => {
  if (window.mascraftProductPriceSup) return;
  window.mascraftProductPriceSup = true;

  const selector = '[data-price-sup-amount], [data-price-sup-compare], [data-price-inline]';
  const rendered = new WeakMap();
  const moneyPattern = /^(\D*?)(\d+(?:[.,'’\u00a0\u202f ]\d{3})*)([.,]\d{2})?([^\d]*)$/u;

  function moveEuroToEnd(price) {
    const parts = price.textContent.match(moneyPattern);
    if (!parts || parts[1].trim() !== '€' || !['', 'EUR'].includes(parts[4].trim())) return;

    const walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
    let remaining = parts[1].length;
    let lastNode;
    while (walker.nextNode()) {
      lastNode = walker.currentNode;
      const count = Math.min(remaining, lastNode.length);
      lastNode.deleteData(0, count);
      remaining -= count;
    }
    remaining = parts[2].length + (parts[3] || '').length;
    walker.currentNode = price;
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (remaining <= node.length) {
        node.insertData(remaining, '€');
        break;
      }
      remaining -= node.length;
    }
  }

  function enhance(price) {
    price.querySelectorAll('[data-price-sup-part]').forEach((sup) => {
      sup.replaceWith(...sup.childNodes);
    });
    price.normalize();
    moveEuroToEnd(price);
    // Sidebar recommendations keep the complete amount on the same baseline.
    if (price.closest('.product__meta-recommendations-sidebar')) return;
    const text = price.textContent;

    // Keep Shopify's amount and separators; only the euro moves to the right.
    // Three-digit groups are thousands; unsupported formats retain their original HTML.
    const parts = text.match(moneyPattern);
    if (!parts) return;

    const integerStart = parts[1].length;
    const integerEnd = integerStart + parts[2].length;
    const euroStart = text.indexOf('€', integerEnd);
    const walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let offset = 0;
    while (walker.nextNode()) {
      nodes.push({ node: walker.currentNode, start: offset });
      offset += walker.currentNode.textContent.length;
    }

    // Wrap text within existing money markup, preserving currency-app wrappers.
    nodes.forEach(({ node, start }) => {
      const value = node.textContent;
      const fragment = document.createDocumentFragment();
      const boundaries = [0, integerStart - start, integerEnd - start, euroStart - start, euroStart + 1 - start, value.length]
        .filter((point) => point >= 0 && point <= value.length)
        .sort((a, b) => a - b);
      for (let i = 1; i < boundaries.length; i += 1) {
        const from = boundaries[i - 1];
        const to = boundaries[i];
        if (from === to) continue;
        const content = value.slice(from, to);
        if (start + from < integerStart || start + from >= integerEnd) {
          const sup = document.createElement('sup');
          sup.dataset.priceSupPart = '';
          if (content === '€') sup.dataset.priceSupCurrency = '';
          sup.setAttribute('role', 'presentation');
          sup.textContent = content;
          fragment.append(sup);
        } else {
          fragment.append(document.createTextNode(content));
        }
      }
      node.replaceWith(fragment);
    });
  }

  function collect(root, targets) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches(selector)) targets.add(root);
    root.querySelectorAll(selector).forEach((price) => targets.add(price));
  }

  function refresh(targets) {
    observer.disconnect();
    targets.forEach((price) => {
      if (!price.isConnected || rendered.get(price) === price.innerHTML) return;
      // Liquid already rendered this amount. Only reformat after a real price update.
      if (!rendered.has(price) && price.querySelector('[data-price-sup-part]') && !price.closest('.product__meta-recommendations-sidebar')) {
        rendered.set(price, price.innerHTML);
        return;
      }
      if (price.hasAttribute('data-price-sup-amount')) {
        enhance(price);
      } else {
        moveEuroToEnd(price);
      }
      rendered.set(price, price.innerHTML);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // Inspect only affected price nodes and inserted subtrees (sliders, filters, cart, quick view).
  const observer = new MutationObserver((records) => {
    const targets = new Set();
    records.forEach((record) => {
      const element = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      const price = element?.closest(selector);
      if (price) targets.add(price);
      record.addedNodes.forEach((node) => collect(node, targets));
    });
    if (targets.size) refresh(targets);
  });

  function initialize() {
    const targets = new Set();
    collect(document.body, targets);
    refresh(targets);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
